import { XCircle } from 'lucide-react';

import { Pill } from '@/components/ui/pill';
import { ActiveFilterOptions, FilterSelection } from '@/types';
import { allObjectValuesAreEmpty } from '@/utils/helpers/all-object-keys-are-empty';
import { tv } from '@/utils/styles';

export interface ActiveScheduleFiltersProps {
  activeFilterOptions?: ActiveFilterOptions;
  activeFilters: FilterSelection;
  onRemoveItem: (key: keyof FilterSelection, filter: string | boolean) => void;
  onRemoveAllFilters: () => void;
  className?: string;
}

const ActiveScheduleFilters = ({
  activeFilterOptions,
  activeFilters,
  onRemoveItem,
  onRemoveAllFilters,
  className,
}: ActiveScheduleFiltersProps) => {
  const { base, list, listItem, pill, actions, actionButton } = styles();

  if (!activeFilters || allObjectValuesAreEmpty(activeFilters)) {
    return null;
  }

  return (
    <div className={base({ className })}>
      <ul className={list()}>
        {activeFilterOptions &&
          Object.entries(activeFilterOptions).map(([filterType, items]) => {
            return items.map((item) => (
              <li key={item.value} className={listItem()}>
                {/* <button
                  type="button"
                  onClick={() => onRemoveItem(filterType as keyof FilterSelection, item.value)}
                  className={pill()}
                >
                  {item.label}
                  <XCircle size={14} className="ml-1 text-lightBlue-600" />
                </button> */}
                <Pill
                  label={item.label}
                  onClick={() => onRemoveItem(filterType as keyof FilterSelection, item.value)}
                  iconRight={<XCircle size={14} />}
                  className={pill()}
                />
              </li>
            ));
          })}
      </ul>
      <div className={actions()}>
        <button onClick={onRemoveAllFilters} type="button" className={actionButton()}>
          Clear filters
        </button>
      </div>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'border-b-solid -mx-2 mb-3 flex items-center border-b border-b-grey-300 px-4 pb-3',
    list: 'mb-1 flex flex-wrap gap-2 md:mt-2',
    listItem: 'flex items-center text-sm',
    pill: '[&_svg]:transition-colors [&_svg]:hover:text-text-primary',
    actions: 'ml-2.5 flex shrink-0 divide-x divide-grey-300 self-start pt-2 md:pt-4',
    actionItem: 'flex items-center',
    actionButton: 'flex-items-center text-baseSm font-medium text-grey-800 hover:underline',
  },
});

export { ActiveScheduleFilters };
